import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { Formik, Form } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../../../api/context';
import Icon from '../../../../components/Icon';
import addr from '../../../../components/addr';
import { Title } from '../../../../utils/title';
import toast from '../../../../utils/toast';
import Layout from '../Layout';
import styles from './Address.module.scss';

const Address = () => {

  const [ loading, setLoading ] = useState(true);
  const [ initial, setInitial ] = useState({
    addr_line_1: '',
    addr_line_2: '',
    addr_city: '',
    division: '',
    post_code: '',
    country: '',
  });

  const { token } = useAPIContext();

  useEffect(() => {

    api(token).v1.profile.address.query()
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          setInitial({
            addr_line_1: res.body.data.addr_line_1,
            addr_line_2: res.body.data.addr_line_2,
            addr_city: res.body.data.addr_city,
            division: res.body.data.division,
            post_code: res.body.data.post_code,
            country: res.body.data.country,
          });
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  return (
    <>
      <Title value='Address - Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.header}>
              <Link
                to='/profile'
                aria-label='go back'>

                <Icon name={'arrow_back'} />

              </Link>

              <h1>Change Address</h1>
            </div>

            <Formik
              enableReinitialize={true}
              initialValues={initial}
              validateOnChange={false}
              validationSchema={yup.object({
                addr_line_1: yup.string()
                  .required('Required'),
                addr_line_2: yup.string(),
                addr_city: yup.string()
                  .required('Required'),
                division: yup.string()
                  .required('Required'),
                post_code: yup.string()
                  .required('Required'),
                country: yup.string()
                  .required('Required'),
              })}
              onSubmit={(values, actions) => {

                if (loading) {
                  return;
                }

                setLoading(true);

                api(token).v1.profile.address
                  .update(values)
                  .then(res => {
                    setLoading(false);

                    if (res.status === 200) {
                      toast.show(toast.KIND.SUCCESS, 'Address saved.');
                    }

                    if (res.status === 400) {
                      toast.show(toast.KIND.ERROR, res.body);
                    }
                  })
                  .catch(err => {
                    setLoading(false);
                    toast.show(toast.KIND.WARNING, err);
                  });

              }} >

              <Form>

                <addr.AddrLine1 loading={loading} />
                <addr.AddrLine2 loading={loading} />
                <addr.City loading={loading} />
                <addr.Division loading={loading} />
                <addr.PostCode loading={loading} />
                <addr.Country loading={loading} />

                <button
                  type='submit'
                  disabled={loading}>

                  Save

                </button>
              </Form>

            </Formik>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Address;